import React from 'react'
import MediaQuery from 'react-responsive'

import { Link } from 'react-router-dom'

const ConexxeBannerVivo = () => (
  <div className='bx-bannerConexxe pos-relative pb-2'>
    <div className='container px-0'>
      <div className='row mx-0'>
        <div className='col-12 px-1 px-sm-0 txt-center'>
          <Link to={'/search?category=5'} title='Veja nossos produtos'>
            <MediaQuery maxDeviceWidth={475}>
              <img src='https://vertemmodulosprd.blob.core.windows.net/banners/vivo_masters20_MAI_banner_1180x300_cat_premio_B_01.jpg' alt='Veja nossas viagens' className='w-100' />
            </MediaQuery>
            <MediaQuery minDeviceWidth={476}>
              <img src='https://vertemmodulosprd.blob.core.windows.net/banners/vivo_masters20_MAI_banner_1180x300_cat_premio_B_01.jpg' alt='Veja nossas viagens' className='w-100' />
            </MediaQuery>
          </Link>
        </div>
      </div>
    </div>
  </div>
)

export default ConexxeBannerVivo



// WEBPACK FOOTER //
// ./src/features/Slider/ConexxeBannerVivo.js